var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIAlramOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.71591 7.4726C6.53621 7.98335 6.43217 8.53193 6.41325 9.09944L6.24301 13.8475C6.23355 14.1786 6.1106 14.4907 5.90252 14.7461L4.5973 16.3446C4.22843 16.7891 4.55001 17.4701 5.12695 17.4701H9.38309C9.38309 18.8889 10.5843 20.0995 12.0124 20.0995C13.4406 20.0995 14.6418 18.8983 14.6418 17.4701H16.7037L6.71591 7.48205V7.4726Z",
    fill: "#D2D6DC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1222 14.7456C17.9142 14.4902 17.8007 14.1781 17.7818 13.847L17.621 9.28809C17.5264 6.51678 15.5118 4.1049 12.7595 3.74548C11.0571 3.52793 9.48701 4.06706 8.32366 5.08857L6.27126 3.01718C5.99697 2.74289 5.54299 2.74289 5.2687 3.01718C4.99442 3.29148 4.99442 3.74548 5.2687 4.01977L7.38731 6.13845L18.7086 17.4601L18.8883 17.6398C19.0302 17.7817 19.2099 17.8479 19.3896 17.8479C19.5693 17.8479 19.749 17.7817 19.8909 17.6398C20.1652 17.3656 20.1652 16.9115 19.8909 16.6373L18.1128 14.7361L18.1222 14.7456Z",
    fill: "#D2D6DC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIAlramOff);
export default __webpack_public_path__ + "static/media/i_alram_off.5780cc4c5f8f1be312f8ceccdcf07c4d.svg";
export { ForwardRef as ReactComponent };